

export function sortData(node1, node2) {
    return new Date(node2.node.frontmatter.date) - new Date(node1.node.frontmatter.date)    
}